export default "__VITE_ASSET__BSvo1KXa__"